// extracted by mini-css-extract-plugin
module.exports = {"root":"menu-item_root__v8aCG","link":"menu-item_link__wnHUU"};